import { render, staticRenderFns } from "./Trait.vue?vue&type=template&id=37fe15c2&scoped=true"
import script from "./Trait.vue?vue&type=script&lang=js"
export * from "./Trait.vue?vue&type=script&lang=js"
import style0 from "./Trait.vue?vue&type=style&index=0&id=37fe15c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fe15c2",
  null
  
)

export default component.exports